import { getRecommendedMemoryTracker } from 'utils/memoryTracker';

export const getHasRecommendedMemoryTracker = () => !!getRecommendedMemoryTracker();
